import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { OrganizationService } from './generatedServices';
import { switchMap } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class PermissionsResolver implements Resolve<void> {
  constructor(private authService: AuthenticationService, private orgService: OrganizationService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<void> {
  const orgSlug = route.paramMap.get('organizationId');
  
  return this.orgService.getOrganization(orgSlug).pipe(
    switchMap((org) => {
      return this.authService.loadPermissions(org.id);
    })
  );
}
}
